import { useEffect, useState } from 'react';

export const useTimeout = (timeout = 500): boolean => {
  const [timerDone, setTimerDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimerDone(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return timerDone;
};

const useHandleLongRunningFetch = (isInitialized: boolean, callback: () => void) => {
  const timeoutDone = useTimeout(3000);

  useEffect(
    function handleLongRunningFetch() {
      if (timeoutDone && !isInitialized) {
        callback();
      }
    },
    [isInitialized, timeoutDone, callback]
  );
};

export default useHandleLongRunningFetch;
